import PropTypes from "prop-types";
import React from "react";

import DataTable from "../../../DataTable";

import useOutputReportStore from "../../../../store/OutputReport.store";
import {
  extractRowKeys,
  formatDataTableColumns,
  getOutputType,
  insertTotalData,
  validateObjectWithoutTotal,
} from "../../../../utils/helpers/dataTable";
import { dataTableCopy } from "../../../../utils/resources/dataTableCopy";

const getFootnote = ({ reportType, assetType, type }) => {
  const footnotes = {
    cash: {
      equity: {
        gics: (
          <>
            {dataTableCopy.unlessOtherwiseStated}
            <br />
            [1]{dataTableCopy.sectorExposure}
            <br />
            [2]{dataTableCopy.targetPortfolios}
            <br />
            [3]{dataTableCopy.seeBenchmark}
          </>
        ),
        risk: (
          <>
            {dataTableCopy.unlessOtherwiseStated}
            <br />
            [1]{dataTableCopy.equitySecuritiesSector}
            <br />
            [2]{dataTableCopy.targetPortfolios}
            <br />
            [3]{dataTableCopy.seeBenchmark}
          </>
        ),
      },
      default: (
        <>
          {dataTableCopy.unlessOtherwiseStated}
          <br />
          [1]{dataTableCopy.proposalNotMaintained}
          <br />
          [2]{dataTableCopy.seeReferenceIndex}
        </>
      ),
    },
    transition: {
      equity: {
        gics: (
          <>
            [1]{dataTableCopy.sectorExposure}
            <br />
            [2]{dataTableCopy.existingPortfolioInformation}
            <br />
            [3]{dataTableCopy.transitionAnalysisDiscussed}
            <br />
            [4]{dataTableCopy.seeBenchmark}
          </>
        ),
        risk: (
          <>
            [1]{dataTableCopy.equitySecuritiesSector}
            <br />
            [2]{dataTableCopy.existingPortfolioInformation}
            <br />
            [3]{dataTableCopy.transitionAnalysisDiscussed}
            <br />
            [4]{dataTableCopy.seeBenchmark}
          </>
        ),
      },
      default: (
        <>
          {dataTableCopy.unlessOtherwiseStated}
          <br />
          [1]{dataTableCopy.existingPortfolioInformation}
          <br />
          [2]{dataTableCopy.modelAndTransitionAnalysis}
          <br />
          [3]{dataTableCopy.seeReferenceIndex}
        </>
      ),
    },
  };

  if (assetType === "equity" && type !== "") {
    return footnotes[reportType][assetType][type];
  }

  return footnotes[reportType]["default"];
};

const SectorsDataTable = ({ reportName, type }) => {
  const data = useOutputReportStore((state) => state.data);
  const types = useOutputReportStore((state) => state.types);
  const { reportType, assetType } = getOutputType(data);

  let formattedTableColumnsData = formatDataTableColumns(reportName, data);
  const tableRowKeys = extractRowKeys(reportName, data);

  if (
    assetType === "equity" &&
    validateObjectWithoutTotal(formattedTableColumnsData)
  ) {
    formattedTableColumnsData = insertTotalData(formattedTableColumnsData);
    tableRowKeys.push({
      label: "Total",
      key: "Total",
    });
  }

  return (
    <DataTable
      reportType={reportType}
      variation="stylized"
      tableCaption={`${reportName} Data Table`}
      tableRowHeaderKey={assetType === "equity" ? "Sectors[1]" : "Sectors"}
      tableRowKeys={tableRowKeys}
      tableColumns={formattedTableColumnsData}
      tableDataTypes={types?.[reportName]}
      formatCellDataBy="row"
      footnote={getFootnote({ reportType, assetType, type })}
      hasProfitLabel={assetType === "equity"}
      name={reportName}
    />
  );
};

SectorsDataTable.propTypes = {
  reportName: PropTypes.string,
  type: PropTypes.string,
};

export default SectorsDataTable;
